import StopDetail from './container'

export default StopDetail
